module.exports = __webpack_public_path__ + "static/media/eye.844b84df.svg";